<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" x="0" y="0" viewBox="0 0 24 24" style="enable-background: new 0 0 24 24" xml:space="preserve" class="">
  <g>
    <g fill="#000" fill-rule="evenodd" clip-rule="evenodd"><path d="M2 11h20v2H2zM2 5h20v2H2zM2 17h20v2H2z" fill="#fff" opacity="1" data-original="#ffffff" class=""></path></g>
  </g>
</svg>
